import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from '@angular/material';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { ChatRoomRoutingModule, SignalRService } from '@modules/chat-room';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ChatRoomRoutingModule,
        MaterialModule,
        LayoutModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        MatDatepickerModule
    ],
    providers: [
        SignalRService,
        DatePipe
    ]
})
export class ChatRoomModule { }
